import {getLocalizationService} from '~/shared/services/localisationService';

import CustomTableRow from './CustomTableRow';

const CustomTableFooter = ({columns, rows, withRoundedCorners, customTableFooterColor}) => {
  const {t} = getLocalizationService();

  return (
    <tfoot>
      {rows?.map((row, index) => (
        row.isTotalAmountRow && (
          <CustomTableRow
            // eslint-disable-next-line react/no-array-index-key
            key={index}
            columns={columns}
            rowData={row}
            withRoundedCorners={withRoundedCorners}
            customTableFooterColor={customTableFooterColor}
            role="columnheader"
            isFooterCell
            t={t}
          />
        )
      ))}
    </tfoot>
  );
};

export default CustomTableFooter;
